<template>
<div>
  <el-row class="mr-b25" style="height: calc(100% - 237px);">
    <div class="title-h4 title-bar tit">수집 설정 구분 관리</div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="setting-addel">
        <el-button @click="onAddButtonClick"><i class="far fa-plus" /></el-button>
        <el-button @click="onDeleteButtonClick" :disabled="selectedRow==null"><i class="far fa-minus" /></el-button>
      </div>
      <div class="vertical-center-box">
        <w-header-search-button type="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper style="height:calc(100% - 67px);" :fit-height="true" :data="rscGetdataTypeTableData" :columns="rscGetdataTypeTableColumns" :column-default="columnDefault" ref="rscGetdataTypeTable" @row-click="clickRow" highlight-current-row :pagination="false" :show-search-tool="showSearchTool"
      row-class-name="c-pointer" :show-custom-header="true">
    </el-table-wrapper>
  </el-row>
  <el-row>
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="title-h4">수집설정 구분 상세정보</div>
      <div>
        <el-button type="primary" :disabled="!modified" @click="onSaveButtonClick">저장</el-button>
        <el-button :disabled="!modified" @click="onCancelButtonClick">취소</el-button>
      </div>
    </el-row>
    <hr/>
    <el-form label-position="top" :model="rscGetdataTypeFormData" ref="rscGetdataTypeForm" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="수집설정 구분 ID" prop="rscGetdataTypeId">
            <el-input ref="idField" v-model="rscGetdataTypeFormData.rscGetdataTypeId" :disabled="!addFlag"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="수집설정 구분명" prop="rscGetdataTypeName">
            <el-input ref="nameField" v-model="rscGetdataTypeFormData.rscGetdataTypeName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import clone from 'lodash/clone';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import RscAPI from '@/api/model/rsc';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';

export default {
  name: 'WRscGetdataTypeSetting',
  props: {
    rscGetmethodId: String,
  },
  data() {
    return {
      showSearchTool: false,
      selectedRow: null,
      addFlag: false,
      modified: false,
      columnDefault,
      originalFormData: {},
      rscGetdataTypeTableData: [],
      rscGetdataTypeTableColumns: [
        {
          prop: 'rscGetdataTypeId',
          label: '구분 ID',
          searchable: true,
        },
        {
          prop: 'rscGetdataTypeName',
          label: '수집설정 구분명',
          searchable: true,
        },
      ],
      rules: {
        rscGetdataTypeId: {
          required: true,
          validator: this.validateRscGetdataTypeId,
          trigger: 'blur',
        },
        rscGetdataTypeName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      rscGetdataTypeFormData: {},
    };
  },
  watch: {
    addFlag: {
      handler(value) {
        if (value) {
          this.rscGetdataTypeFormData = this.createNewRscgetdataTypeData();
          this.originalFormData = clone(this.rscGetdataTypeFormData);
          this.modified = false;
        }
      },
    },
    selectedRow: {
      handler(object) {
        if (!isNil(object)) {
          this.rscGetdataTypeFormData = clone(object);
          this.$emit('select-rsc-getdata-type', object);
          this.originalFormData = clone(this.rscGetdataTypeFormData);
          this.modified = false;
        }
      },
    },
    rscGetdataTypeFormData: {
      deep: true,
      handler(value) {
        this.modified = !isEqual(this.originalFormData, value);
      },
    },
  },
  methods: {
    loadData() {
      RscAPI.getRscGetdataTypeList(this.rscGetmethodId).then((response) => {
        if (response.data.success) {
          this.rscGetdataTypeTableData = response.data.data;
          if (!isEmpty(this.rscGetdataTypeTableData)) {
            let selectedRow = null;
            if (isNil(this.selectedRow)) {
              selectedRow = this.rscGetdataTypeTableData[0];
            } else {
              selectedRow = this.rscGetdataTypeTableData.find((object) => object.rscGetdataTypeId === this.selectedRow.rscGetdataTypeId);
              selectedRow = isNil(selectedRow) ? this.rscGetdataTypeTableData[0] : selectedRow;
            }
            this.clickRow(selectedRow);
            this.$nextTick(() => {
              this.$refs.rscGetdataTypeTable.$children[0].setCurrentRow(selectedRow);
              this.$refs.rscGetdataTypeForm.clearValidate();
            });
          } else {
            this.selectedRow = null;
            this.onAddButtonClick();
          }
        }
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onAddButtonClick() {
      this.addFlag = true;
      this.$refs.rscGetdataTypeForm.clearValidate();
      this.$nextTick(() => {
        this.$refs.idField.focus();
      });
    },
    createNewRscgetdataTypeData() {
      return {
        rscGetdataTypeId: null,
        rscGetdataTypeName: null,
      };
    },
    clickRow(row) {
      this.addFlag = false;
      this.selectedRow = clone(row);
      this.$refs.rscGetdataTypeForm.clearValidate();
    },
    onDeleteButtonClick() {
      const rscGetmethodId = this.selectedRow.rscGetmethodId;
      const rscGetdataTypeId = this.selectedRow.rscGetdataTypeId;
      const params = {
        rscGetmethodId,
        rscGetdataTypeId,
      };
      RuleSettingsAPI.checkRscGetmethodInfoInUse(params).then((response) => {
        const target = '수집설정 구분';
        const action = msgUtil.action.DELETE;
        if (response.data.success) {
          if (response.data.data) {
            this.$message(msgUtil.getCustomMsgData('현재 사용 중인 수집설정구분은 삭제할 수 없습니다.'));
          } else {
            this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
              RuleSettingsAPI.deleteRscGetdataType(params)
                .then((deleteResponse) => {
                  if (deleteResponse.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.loadData();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                });
            });
          }
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      });
    },
    onSaveButtonClick() {
      const rscGetdataTypeList = this.rscGetdataTypeTableData;
      this.$refs.rscGetdataTypeForm
        .validate()
        .then((response) => {
          const params = clone(this.rscGetdataTypeFormData);
          // temp.rscGetmethodId = this.selectedRow.rscGetmethodId;
          if (response) {
            const target = '수집설정 구분';
            if (this.addFlag) {
              const action = msgUtil.action.ADD;
              params.orderbyIndex = rscGetdataTypeList.length > 0 ? rscGetdataTypeList[rscGetdataTypeList.length - 1].orderbyIndex + 1 : 1;
              params.rscGetmethodId = this.rscGetmethodId;
              RuleSettingsAPI.insertRscGetdataType(params)
                .then((saveResponse) => {
                  if (saveResponse.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.loadData();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                });
            } else {
              const action = msgUtil.action.SAVE;
              RuleSettingsAPI.updateRscGetdataType(params)
                .then((saveResponse) => {
                  if (saveResponse.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.loadData();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                });
            }
          }
        })
        .catch(() => {});
    },
    onCancelButtonClick() {
      this.rscGetdataTypeFormData = clone(this.originalFormData);
      if (this.addFlag) {
        this.$refs.idField.focus();
      } else {
        this.$refs.nameField.focus();
      }
    },
    validateRscGetdataTypeId(rule, value, callback) {
      if (!this.addFlag) {
        callback();
      }
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('필수 정보입니다.'));
      } else {
        RuleSettingsAPI.checkRscGetdataTypeIdValidation({
          rscGetmethodId: this.selectedRow.rscGetmethodId,
          rscGetdataTypeId: value,
        }).then((response) => {
          if (response.data.data) {
            callback();
          } else {
            callback(new Error('이미 사용 중인 ID입니다.'));
          }
        });
      }
    },
    clear() {
      this.selectedRow = null;
      this.addFlag = false;
      this.modified = false;
      this.rscGetdataTypeFormData = this.createNewRscgetdataTypeData();
      this.$refs.rscGetdataTypeForm.clearValidate();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/RscGetdataTypeSetting.vue